module.exports = __webpack_public_path__ + "img/img3.96ed5375.jpg";